
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Project Gemini',
	'appExit': 'Pojdi na pozdravno stran',


	'widgetsListLabel': 'Seznam gradnikov. Izberite gradnik in pritisnite Enter, da ga dodate.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Posodobljeno',
	'dirty': 'Ni posodobljeno',
	'conflict': 'Navzkrižje pri shranjevanju pogleda',
	'error': 'Težava pri shranjevanju pogleda',
	'failure': 'Povezave s strežnikom ni mogoče vzpostaviti',
	'saveFailed': 'Pogleda ni mogoče shraniti',

	'wa_insync': 'Shranjeno',
	'wa_conflict': 'Navzkrižje pri shranjevanju pogleda',
	'wa_error': 'Pogleda ni mogoče shraniti',
	'wa_failure': 'Povezave s strežnikom ni mogoče vzpostaviti',

	// Menu Labels
	'changeDisplay': 'Spremeni prikaz',
	'changeToColumnChart': 'Spremeni v stolpčni grafikon',
	'changeToBubbleChart': 'Spremeni v mehurčni grafikon',
	'toggleMoveHandles': 'Preklopi ročke za premikanje',
	'undo': 'Razveljavi',
	'redo': 'Znova uveljavi',
	'mode': 'Spremeni način',

	'untitled': 'Brez naslova',
	'remove': 'Odstrani',
	'editTitle': 'Urejanje naslova',
	'edit': 'Urejanje',
	'done': 'Opravljeno',

	// Data tray
	'dataTrayHandleOpenLabel': 'Odpri podatkovni pladenj',
	'dataTrayHandleCloseLabel': 'Zapri podatkovni pladenj',

	// Dialogs
	'dlg_loading': 'Nalaganje ...',
	'dlg_ok': 'V redu',
	'dlg_create': 'Ustvari',
	'dlg_cancel': 'Prekliči',
	'dlg_close': 'Zapri',
	'dlg_update': 'Posodobi',
	'dlg_renameBoardTitle': 'Preimenuj objekt',
	'dlg_renameDatasetTitle': 'Preimenuj ta nabor podatkov',
	'dlg_renameSceneTitle': 'Preimenuj to sceno',
	'dlg_NameLabel': 'Ime:',
	'dlg_NewNameLabel': 'Novo ime:',
	'dlg_DefaultNameWithDataSet': 'Pogled %{name}',
	'dlg_ShareTitle': 'Souporaba vsebine',
	'dlg_UnshareTitle': 'Odstrani souporabo vsebine',
	'dlg_ShareUser': 'ID uporabnika:',
	'dlg_NewColumnLabel': 'Ime novega izračuna',

	'dlg_new': 'Novo ...',
	'dlg_open': 'Odpri ...',
	'dlg_makeACopy': 'Ustvari kopijo',
	'dlg_rename': 'Preimenuj ...',
	'dlg_moreToCome': 'Prihaja še več dejanj ...',

	'dlg_use': 'Uporabi',

	'dlg_RelinkDatasetTitle': 'Zamenjaj nabor podatkov \'%{datasetName}\' s ...',

	'open_error': 'Med odpiranjem pogleda je prišlo do težave.',

	// Delete Board
	'del_dialogTitle': 'Potrdi izbris',
	'del_itemMsg': 'Ali ste prepričani, da želite izbrisati \'%{name}\'?',
	'del_itemsMsg': 'Ali ste prepričani, da želite izbrisati naslednje št. postavk: %{count}?',
	'del_deleteErr': '\'%{name}\' ni mogoče izbrisati. ',

	// List Sorting
	'dlg_ascending': 'naraščajoče',
	'dlg_descending': 'padajoče',
	'dlg_custom': 'po meri',
	'dlg_none': 'brez',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Iskanje',

	'searchHint': 'Preiščite vse svoje podatke',
	'clearSearchResult': 'Počisti rezultate iskanja',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Krog',
	'shapesHexagon': 'Šestkotnik',
	'shapesLine': 'Črtni',
	'shapesOctagon': 'Osmerokotnik',
	'shapesPentagon': 'Petkotnik',
	'shapesSquare': 'Kvadrat',
	'shapesTriangle': 'Trikotnik',
	'shapesDiamond': 'Diamant',
	'shapesTitle': 'Lastnosti oblike', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Zaobljeni kvadrate',
	'shapesStar': 'Zvezdica',
	'shapesChevron': 'Škarnice',
	'shapesBadge_ribbon': 'Trak značke',
	'shapesBadge': 'Značka',
	'shapesHeart': 'Srce',
	'shapesExclamation': 'Klicaj',
	'shapesTrendingup': 'Naraščajoči trend',
	'shapesTrendingdown': 'Padajoči trend',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Osebe',
	'shapesFemale': 'Ženska',
	'shapesHappyface': 'Vesel obraz',
	'shapesMale': 'Moški',
	'shapesMan': 'Moški',
	'shapesNeutralface': 'Nevtralen obraz',
	'shapesSadface': 'Žalosten obraz',
	'shapesShakehands': 'Rokovanje',
	'shapesThumbsdown': 'Dol obrnjen palec',
	'shapesThumbsup': 'Gor obrnjen palec',
	'shapesWoman': 'Ženska',

	// Weather and places
	'shapesPlacesWeatherCat': 'Mesta in vreme',
	'shapesCity': 'Mesto',
	'shapesCloud': 'Oblak',
	'shapesEducation': 'Izobraževanje',
	'shapesGovernment': 'Vlada',
	'shapesHalfcloud': 'Pol oblaka',
	'shapesHouse': 'Hiša',
	'shapesMoon': 'Luna',
	'shapesRain': 'Dež',
	'shapesSunny': 'Sončno',

	//Vehicles
	'shapesVehiclesCat': 'Vozila',
	'shapesAirplane': 'Letalo',
	'shapesCar': 'Avtomobil',
	'shapesShip': 'Ladja',
	'shapesShoppingcart': 'Nakupovalni voziček',
	'shapesTrain': 'Vlak',
	'shapesTruck': 'Tovornjak',

	//Objects
	'shapesObjectsCat': 'Objekti',
	'shapesBook': 'Knjiga',
	'shapesBriefcase': 'Kovček',
	'shapesCalendar': 'Koledar',
	'shapesCheck': 'Ček',
	'shapesClock': 'Ura',
	'shapesDesktop': 'Namizje',
	'shapesDocument': 'Dokument',

	'shapesFood': 'Hrana',
	'shapesGear': 'Oprema',
	'shapesHealth': 'Zdravje',

	'shapesIdea': 'Ideja',
	'shapesMobile': 'Mobilno',
	'shapesMoney_bill': 'Bankovec',
	'shapesMoney_coin': 'Kovanec',
	'shapesPiggybank': 'Hranilnik',
	'shapesStackofpaper': 'Kupček denarja',
	'shapesStickynote1': 'Samolepilni listek 1',
	'shapesStickynote2': 'Samolepilni listek 2',
	'shapesTarget': 'Cilj',
	'shapesTool': 'Orodje',

	'shapesUmbrella': 'Dežnik',

	'shapesBrain': 'Možgani',
	'shapesSkull': 'Lobanja',
	'shapesEye': 'Oko',

	// Arrows shapes
	'shapesArrowsCat': 'Puščice',
	'shapesRightArrow': 'Puščica v desno',
	'shapesLeftArrow': 'Puščica v levo',
	'shapesDoubleArrow': 'Dvojna puščica',
	'shapesCurvedArrow': 'Puščica s krivuljo',

	// Callouts shapes
	'shapesCalloutsCat': 'Oblački',
	'shapesRectCallout': 'Oblaček',

	// Images
	'imagesCat': 'Slike',
	'imageWidgetTitle': 'Gradnik slike',
	'imgUrl': 'URL slike',
	'noImgSelected': 'Nobena slika ni izbrana',
	'enterImgUrl': 'Tukaj vnesite URL slike',
	'imgPasteLink': 'Prilepite URL in pritisnite Enter, da ga shranite.',
	'imgResizeToFit': 'Spremeni velikost, da se bo prilagala velikosti slike',
	'imgHeight': 'Višina:',
	'imgWidth': 'Širina:',
	'imgTransparency': 'Prosojnost:',
	'imgMissingUrl': 'URL slike manjka.',
	'imgUrlValidationError': 'URL slike ni veljaven.',
	'imgUrlInvalidDomainError': 'URL slike kaže na domeno, ki je skrbnik ni odobril. Domene, ki jih je odobril skrbnik, so "%{domains}".',

	// line shape
	'propStrokeWidth': 'Debelina črte',
	'propStrokeDashArray': 'Slog črte',
	'propStrokeSolidline': 'Polna črta',
	'propStrokeLineCap': 'Konica črte',
	'propStrokeLineCapButt': 'Do roba',
	'propStrokeLineCapRound': 'Okrogla',
	'propStrokeLineCapSquare': 'Kvadratna',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Predvajaj',
	'dataPlayerValueListLabel': 'Vrednosti predvajalnika podatkov',
	// Text Widget
	'textWidgetTitle': 'Besedilni gradnik',
	'textStyle': 'Slogi',
	'textStyleDescription': 'Predhodno oblikovani slogi pisave',
	'textTitleStyle': 'Naslov',
	'textTitleSmallStyle': 'Majhen naslov',
	'textSubtitleStyle': 'Podnaslov',
	'textBodyStyle': 'Telo',
	'textBodySmallStyle': 'Majhno telo',
	'textCaptionStyle': 'Napis',
	'textQuoteStyle': 'Citat',
	'textQuoteSmallStyle': 'Majhen citat',
	'textResponsiveStyle': 'Samodejna nastavitev velikosti',
	'textAutoFontSize': 'Samodejno',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Izjemno tanko',
	'textFontFamilySubClassThin': 'Tanko',
	'textFontFamilySubClassThinItalic': 'Tanko ležeče',
	'textFontFamilySubClassExtraLight': 'Izjemno lahko',
	'textFontFamilySubClassExtraLightItalic': 'Izjemno lahko ležeče',
	'textFontFamilySubClassLight': 'Svetlo',
	'textFontFamilySubClassLightItalic': 'Lahko ležeče',
	'textFontFamilySubClassRegular': 'Običajno',
	'textFontFamilySubClassRegularItalic': 'Običajno ležeče',
	'textFontFamilySubClassItalic': 'Ležeče',
	'textFontFamilySubClassMedium': 'Srednje',
	'textFontFamilySubClassMediumItalic': 'Srednje ležeče',
	'textFontFamilySubClassHeavy': 'Težko',
	'textFontFamilySubClassHeavyItalic': 'Težko ležeče',
	'textFontFamilySubClassDemiBold': 'Srednje krepko',
	'textFontFamilySubClassDemiBoldItalic': 'Srednje krepko ležeče',
	'textFontFamilySubClassBold': 'Krepko',
	'textFontFamilySubClassBoldItalic': 'Krepko ležeče',
	'textFontFamilySubClassExtraBold': 'Zelo krepko',
	'textFontFamilySubClassExtraBoldItalic': 'Zelo krepko ležeče',
	'textFontFamilySubClassBlack': 'Črno',
	'textFontFamilySubClassBlackItalic': 'Črno ležeče',
	'textFontFamilySubClassStencil': 'Šablona',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Samodejna nastavitev velikosti pisave',
	'responsiveCoachmarkContents': 'Ko spremenite velikost besedila tega tipa, se velikost pisave samodejno spremeni, tako da se prilega. Velikost pisave lahko nastavite v lastnostih besedila.',

	'propText': 'Podrobnosti besedila', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Lastnosti besedila', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Velikost pisave',
	'textFontFamily': 'Družina pisav',
	'textFontWeight': 'Teža pisave', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': 'Povezava na sliko',
	'propMissingURL': 'Vnesite URL',
	'propImgTop': 'Lastnosti slike', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Splošne lastnosti', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Splošno', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Splošno', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Barva polnila', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Barva besedila', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Barva obrobe',
	'propMaintainAxisScales': 'Ohrani merilo osi',
	'propShowItemLabel': 'Pokaži oznako postavke',
	'propHideLegend': 'Skrij legendo',
	'propColorPalette': 'Paleta',
	'propLegendPosition': 'Položaj legende',
	'propHideAxisTitleLabels': 'Skrij naslove osi',
	'propLineColor': 'Barva vrstic',
	'propBubbleColor': 'Barva mehurčka',
	'propInterpolation': 'Gladke črte',
	'propElementColor': 'Barva vizualizacijskega elementa',
	'propSymbolShape': 'Oblika simbola',
	'propHeatScalePalette': 'Vrstni red barv',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Temnejše barve predstavljajo manjše vrednosti.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Temnejše barve predstavljajo večje vrednosti.',
	'propImageDetails': 'Podrobnosti slike', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Podrobnosti spletne strani', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Podrobnosti medija', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Vnesite URL in pritisnite Enter.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Položaj in slog',
	'propPositionLabel': 'Položaj', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'X', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'Y', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': 'Velikost', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': 'Širina',
	'propResizeHeight': 'Višina',
	'propRotateLabel': 'Zavrti',
	'propRotateAngle': 'Kot', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Količina ikon',
	'propScaleDescription': 'Izberite količino ikon',
	'propScaleFew': 'Nizka',
	'propScaleDefault': 'Privzeto',
	'propScaleMany': 'Visoka',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Ta vrednost mora biti številska',

	'mediaAriaLabel': 'Vnos url-ja',
	'dropdownAriaLabel' : 'Spustni seznam',
	'ariaGroupLabel': 'Kategorija spustnega seznama: %{cateoryLabel} postavka: %{itemLabel}. Pritisnite tipko DOWN (navzdol), da razširite. Za pomikanje pritisnite tipki UP (navzgor) in DOWN (navzdol), če želite strniti, pa tipko ESCAPE.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Zadnja osvežitev: pred %{timeInterval}',
	'widgetTimer': 'Časomer gradnika',

	// Theme colors
	'transparent': 'Brez barve',
	'white': 'Bela',
	'lightGrey': 'Svetlo siva',
	'grey': 'Siva',
	'darkGrey': 'Temno siva',
	'black': 'Črno',
	'lightBlue': 'Svetlo modra',
	'blue': 'Modra',
	'darkBlue': 'Temno modra',
	'yellow': 'Rumena',
	'orange': 'Oranžna',
	'lime': 'Svetlo zelena',
	'green': 'Zelena',
	'peach': 'Breskvina',
	'red': 'Rdeča',
	'violet': 'Vijolična',
	'aqua': 'Akva modra',
	'purple': 'Škrlatna',
	'plum': 'Slivova',
	'gray10': 'Siva 10',
	'gray20': 'Siva 20',
	'gray30': 'Siva 30',
	'gray50': 'Siva 50',
	'gray60': 'Siva 60',
	'gray70': 'Siva 70',
	'gray80': 'Siva 80',
	'gray90': 'Siva 90',
	'gray100': 'Siva 100',
	'blue50': 'Modra 50',
	'blue60': 'Modra 60',
	'blue70': 'Modra 70',
	'green40': 'Zelena 40',
	'green50': 'Zelena 50',
	'red50': 'Rdeča 50',
	'red60': 'Rdeča 60',


	//Theme Palette Label
	'paletteLabel': 'IBM-ova paleta %{number}',
	'heatPaletteLabel': 'IBM-ova toplotna paleta %{number}',
	'conditionalPaletteLabel': 'IBM-ova pogojna paleta %{number}',
	'carbonPaletteXLight': 'Carbon X Light',
	'carbonPaletteXDark': 'Carbon X Dark',
	'carbonPalettePurple': 'Škrlatna',
	'carbonPaletteTeal': 'Modrozelena',
	'carbonPaletteCyan': 'Cijan',
	'carbonPaletteMagenta': 'Magenta',
	'carbonPalettePurpleTeal': 'Vijolična in zelenomodra',
	'carbonPaletteCyanMagenta': 'Cijan in magenta',
	'carbonPaletteGreenRed': 'Zelena in rdeča',
	'carbonPaletteGreenYellowRed': 'Zelena, rumena in rdeča',
	'carbonPalettePurpleTealConvergent': 'Vijolična, zelenomodra, podobno',
	'carbonPaletteCyanMagentaConvergent': 'Cijan, magenta, podobno',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'IBM-ova svetla paleta',
	'userPaletteColor_defaultTheme': 'IBM-ova privzeta paleta',
	'userPaletteColor_darkTheme': 'IBM-ova temna paleta',

	// Dashboard
	'propDashboardBackgroundColor': 'Barva ozadja',
	'propLayoutPositioning': 'Pozicija postavitve',
	'propLayoutRelative': 'Relativno',
	'propLayoutAbsolute': 'Absolutno',
	'propLayoutPositioningCoachmarkTitle': 'Izberite slog postavitve',
	'propLayoutPositioningCoachmarkContent': 'V relativni postavitvi se velikost in položaj gradnikov prilagodita tako, da se prilegajo na zaslon. Gradniki v absolutni postavitvi so prikazani v natančno takšni velikosti in postavitvi, kot ju določite, ne glede na velikost zaslona.',
	'gridText': 'Pokaži mrežo',
	'snapText': 'Pripni na mrežo',
	'snapObjectsText': 'Pripni na objekte',
	'fitPageText': 'Prilagodi strani',
	'gridLabel': 'Mreža',
	'heightUnit': 'v',
	'widthUnit': 'š',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Velikost strani',
	'propPageSizePresetAriaLabel': 'Prednastavitev za velikost strani',
	'propPageSizePreset': 'Prednastavitev',
	'propPageSizePresetCustom': 'Po meri',
	'propPageSizePreset16x9': 'Zaslon 16 : 9',
	'propPageSizePreset4x3': 'Zaslon 4 : 3',
	'propPageSizePresetInfographic': 'Vizualna predstavitev',
	'propPageSizeWidth': 'Širina',
	'propPageSizeHeight': 'Višina',
	'propPageSizeWidthAriaLabel': 'Širina velikosti strani',
	'propPageSizeHeightAriaLabel': 'Višina velikosti strani',
	'propPageSizeAdjustedMessage': 'Velikost strani se je povečala, ker je bil vnos pod minimumom ali se ni prilegal na delovno tablo.',
	'propTabShow': 'Pokaži zavihke',
	'propShowTabsInPreview': 'Pokaži zavihke v predogledu',
	'multilingualDashboardsLabel': 'Jeziki',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Privzeto',
	'multilingualDashboardsAddLinkText': 'Dodaj drugi jezik',
	'multilingualDashboardsSelect': 'Izberi',
	'multilingualDashboardsButtonLabel': 'Dodaj',
	'multilingualDashboardTranslationMode': 'Zdaj ste v načinu prevoda (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Opravljeno',
	'multilingualDashboardRemainingStrings': 'Št. preostalih prevodov: %{numTranslationsLeft}',
	'multilingualDashboardRemainingString': 'Ostal je še 1 prevod',
	'multilingualDashboardsSetDefault': 'Nastavi privzeti jezik',
	'multilingualDashboardIconMore': 'Več dejanj za jezik %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Področje, ki ga je mogoče prevesti',
	'multilingualDeleteTitle': 'Izbriši jezik',
	'multilingualDeleteLanguageWarning': 'Ali ste prepričani, da želite izbrisati jezik \'%{language}\'?',
	'multilingualSelectLanguage': 'Izberite jezik',
	'confirmLayoutStyleUpgradeTitle': 'Uveljavi za vse zavihke',
	'confirmLayoutStyleUpgrade': 'Ali želite uveljaviti ta slog postavitve za vse zavihke na delovni tabli?',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Izbriši',
	'tabDeleteDialogTitle': 'Želite izbrisati ta zavihek?',
	'tabDeleteDialogMessage': 'Izbrisana bo tudi vsa vsebina na tem zavihku.',

	// Vis widget
	'propVisTypeReturn': 'Tipi vizualizacije',
	'propVisDetails': 'Podrobnosti',

	// Alignment picker
	'propAlignPickTop': 'Poravnaj zgoraj',
	'propAlignPickRight': 'Poravnaj desno',
	'propAlignPickBottom': 'Poravnaj spodaj',
	'propAlignPickLeft': 'Poravnaj levo',
	'propAlignPickCenter': 'Poravnaj na sredino',
	'propAlignPicker': 'Poravnava',

	// Toolbar picker
	'propToolbarPickBold': 'Krepko',
	'propToolbarPickUnderline': 'Podčrtano',
	'propToolbarPickItalic': 'Ležeče',
	'propToolbarPickJustifyLeft': 'Poravnaj levo',
	'propToolbarPickJustifyCenter': 'Poravnaj na sredino',
	'propToolbarPickJustifyRight': 'Poravnaj desno',
	'propToolbarPickJustify': 'Poravnaj obojestransko',

	'propList': 'Seznam',
	'propOrderedList': 'Urejen seznam',
	'propUnorderedList': 'Neurejen seznam',

	// Symbol shapes
	'propCircle': 'Krog',
	'propTriangle': 'Trikotnik',
	'propSquare': 'Kvadrat',
	'propRect': 'Pravokotnik',
	'propStar': 'Zvezdica',
	'propCross': 'Križ',
	'propPlus': 'Plus',
	'propPoly': 'Mnogokotnik',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': 'Levo',
	'propRight': 'Desno',
	'propTop': 'Zgoraj',
	'propBottom': 'Spodaj',

	// Interpolation options
	'propSmooth': 'Zglajen',
	'propStraight': 'Ravno',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Seznam', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Premakni levo', // screen reader
	'srWidgetMoveUp': 'Premakni navzgor', // screen reader
	'srWidgetMoveRight': 'Premakni desno', // screen reader
	'srWidgetMoveDown': 'Premakni navzdol', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Sorazmerno povečaj velikost', // screen reader
	'srWidgetResizeSmaller': 'Sorazmerno pomanjšaj velikost', // screen reader
	'srWidgetResizeBiggerV': 'Navpično povečaj velikost', // screen reader
	'srWidgetResizeSmallerV': 'Navpično pomanjšaj velikost', // screen reader
	'srWidgetResizeBiggerH': 'Vodoravno povečaj velikost', // screen reader
	'srWidgetResizeSmallerH': 'Vodoravno pomanjšaj velikost', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Zavrti v smeri urinega kazalca', // screen reader
	'srWidgetRotateCCW': 'Zavrti v nasprotni smeri urinega kazalca', // screen reader

	// Recommended types
	'visChange': 'Spremeni vizualizacijo',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Vizualizacija',
	'chartLabel': 'Grafikon %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Pritisnite F12 za pomikanje znotraj gradnika',
	'f10KeyDescription': 'Pritisnite F10, da zaženete pogled žarišča gradnik',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} z vrednostjo %{value}',

	'shapeColorLabel': 'Barva oblike',
	'showLegendLabel': 'Pokaži legendo',

	//Webpage
	'webpageWidgetTitle': 'Gradnik spletne strani',
	'webpagePasteLink': 'Prilepite URL in pritisnite Enter, da ga shranite.',
	'propWebpageLink': 'URL spletne strani',
	'propWebpageTitle': 'Naslov spletne strani',
	'propWebpageTitleDescription': 'Naslov spletne strani',
	'webpageUrl': 'URL spletne strani',
	'noWebpageSelected': 'Nobena spletna stran ni izbrana',
	'enterWebpageUrl': 'Tukaj vnesite URL spletne strani',
	'propWebpageTop': 'Lastnosti spletne strani', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'URL spletne strani manjka.',
	'webpageUrlValidationError': 'URL spletne strani ni veljaven.',
	'webpageHttpValidationError': 'Do spletne strani morate dostopati s povezavo HTTPS.',
	'webpageInvalidDomainError': 'URL spletne strani kaže na domeno, ki je skrbnik ni odobril. Domene, ki jih je odobril skrbnik, so "%{domains}".',

	//VizState
	'vzErrorLoading': 'Vizualizacije ni mogoče naložiti',
	'vzErrorLoadingMissingData': 'Vizualizacije ni mogoče naložiti, manjkajoči kontekstni podatki',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Gradnik medijev',
	'mediaPasteLink': 'Prilepite URL in pritisnite Enter, da ga shranite.',
	'mediaUrl': 'URL medija',
	'noMediaSelected': 'Noben medij ni izbran',
	'enterMediaUrl': 'Tukaj vnesite URL medija',
	'videoHeight': 'Višina:',
	'videoWidth': 'Širina:',
	'propMediaLink': 'Povezava na medij',
	'propMediaTitle': 'Naslov medija',
	'propMediaTitleDescription': 'Naslov medija',
	'propMediaTop': 'Lastnosti medija', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'URL povezave na medij manjka.',
	'mediaUrlValidationError': 'URL datoteke medija ni veljaven.',
	'mediaUnknownValidationError': 'Ta tip medija ni podprt.',
	'mediaHttpValidationError': 'Do datoteke medija morate dostopati s povezavo HTTPS.',
	'mediaInvalidDomainError': 'URL medijske datoteke kaže na domeno, ki je skrbnik ni odobril. Domene, ki jih je odobril skrbnik, so "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Lastnosti', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Nabor podatkov',
	'dataViewsLabel': 'Pogled',
	'columnQuality': 'Kakovost podatkov',
	'columnProperties': 'Lastnosti podatkov',

	'dataQuality': 'Kakovost podatkov',
	'dataQualityRowCount': 'Število vrstic',
	'dataQualityDistribution': 'Distribucija',
	'dataRowLabel': 'Podatki',

	// Modelling UI
	'typeColumn': 'Tip',
	'modellingColumnType': 'Tip',
	'modellingColumnAggregation': 'Agregiranje',
	'modellingColumnUsage': 'Uporaba',
	'modellingColumnSort': 'Razvrsti',
	'modellingColumnFormat': 'Oblika',
	'modellingColumnCategory': 'Kategorija',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Nalaganje ...',

	'modellingProcessing': 'Obdelava ...',
	'modellingImport': 'Uvozi',
	'modellingReimport': 'Znova uvozi',
	'modellingDatasourceTitle': 'Izvor podatkov',
	'modellingImportStartedTitle': 'Uvažanje se je začelo',
	'modellingImportStartedText': 'Uvažanje podatkov lahko traja nekaj časa. (Med uvažanjem podatkov lahko ustvarite pogled.)',
	'importDatasourceTitle': 'Povezave',
	'dropHere': 'Spustite tukaj, da ustvarite nov izvor podatkov ...',
	'browseButton': 'Prebrskaj',
	'errorNoData': 'Ni podatkov za obdelavo.',
	'errorNoFile': 'Ni datotek za nalaganje.',
	'errorUploadFailed': 'Nalaganje ni mogoče.',
	'uploadSucceessful': 'Nalaganje je uspelo',
	'del_datasourceTitle': 'Izbriši nabor podatkov',
	'del_datasourceMsg': 'Ali ste prepričani, da želite izbrisati \'%{name}\'?',
	'modellingFileUpdate': 'Posodobi',
	'modellingFileUpdateTitle': 'Posodobi nabor podatkov',
	'modellingFileUpdateDescription': 'Ali želite posodobiti \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Posodabljanje \'%{name}\'',
	'modellingUpdateStartedTitle': 'Posodobitev uvoza se je začela',
	'modellingUpdateStartedText': 'Posodabljanje podatkov lahko traja nekaj časa.\n\n(Med posodabljanjem podatkov lahko ustvarite pogled.)',
	'modellingErrorImportUploadNoFile': 'Ni datotek za nalaganje.',
	'modellingErrorImportUploadFailed': 'Nalaganje ni mogoče.',
	'modellingErrorImportUploadInvalidType': 'Tip datoteke ni veljaven.',
	'modellingErrorImportUploadTableFailed': 'Pridobivanje tabel ni uspelo.',
	'modellingIntentResultsTitle': 'Izberite predlagan nabor podatkov za uporabo',
	'modellingColumnViewRelationships': 'Prikaži povezane tabele',
	'modellingTableRelatedTables': 'Tabele, povezane z \'%{name}\'',
	'modellingTable': '%{name} - tabela',
	'modellingColumnIncludedInDataSet': 'Dodano',
	'modellingDataSet': 'Nabor podatkov',
	'modellingViewInDataSet': 'Prikaži v naboru podatkov',
	'modellingViewRelatedTables': 'Prikaži povezane',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Najdena ni nobena povezana tabela',

	'modellingValidatingDataset': 'Preverjanje ...',
	'datasetFinishedRefreshing': 'Nabor podatkov %{datasetName} je bil osvežen.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Razreši pot spoja:',
	'modellingJoinColumns': 'Definirajte pot spoja za tabelo: %{name}',
	'modellingJoinToTable': 'Pridruži se tabeli: %{name}',

	// Data Quality
	'excluded': 'Izključeno',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filter',
	'modellingColumnSortNone': 'Počisti razvrščanje',
	'modellingColumnSortAsc': 'Razvrsti naraščajoče',
	'modellingColumnSortDesc': 'Razvrsti padajoče',
	'modellingColumnRemove': 'Odstrani ta stolpec',

	// Import File Browser
	'dropboxPageTitle': 'Nova povezava Dropbox',
	'sizeColumn': 'Velikost',

	//Modelling Column Property Values
	'dataType_string': 'Niz (String)',
	'dataType_date': 'Datum',
	'dataType_integer': 'Celo število (Integer)',
	'dataType_double': 'Realno število z dvojno natančnostjo (Double)',
	'dataType_float': 'Realno število s plavajočo vejico (Float)',
	'dataType_boolean': 'Logična vrednost (Boolean)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Število',
	'defaultAggregation_countdistinct': 'Razlikovalno štetje',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Povprečno',
	'defaultAggregation_sum': 'Vsota',
	'defaultAggregation_auto': 'Samodejno (%{aggregationType})',

	'type_fact': 'Dejstvo',
	'type_attribute': 'Atribut',

	'defaultSort_none': 'Ne razvrsti',
	'defaultSort_asc': 'Razvrsti naraščajoče',
	'defaultSort_desc': 'Razvrsti padajoče',

	'category_none': 'Brez',
	'category_location': 'Lokacija',
	'category_monetary': 'Denarno',
	'category_time': 'Čas',

	// Root menu
	'rootMenuTitle': 'Glavni meni',

	'errorMessageTitle': 'Napaka',
	'errorMessageDetails': 'Podrobnosti: ',
	'errorMessageTitleAssetAlreadyExists': 'Sredstvo že obstaja',

	'defaultTabTitle': 'Zavihek %{index}',
	'tabAddBtnTitle': 'Dodaj nov zavihek',

	'unsupportedConditionalFormattingEncountered': 'Pogojno oblikovanje ni več uveljavljeno za nekatere stolpce.',


	// Homepage View
	'nameColumn': 'Ime',
	'creatorColumn': 'Ustvaril',
	'creationDateColumn': 'Datum ustvarjanja',
	'versionColumn': 'Različica',
	'modifiedColumn': 'Nazadnje spremenjeno',

	'filterBy': 'Filtriraj postavke',
	'allFilter': 'Vse postavke',
	'createdByMeFilter': 'Ustvaril jaz',
	'sharedWithMeFilter': 'V skupni rabi z mano',
	'favoritesFilter': 'Moje priljubljene',
	'recentsFilter': 'Nedavno dodano',
	'sortBy': 'Razvrsti po',

	// Sort Menu
	'sortModified': 'Spremenjeno',
	'sortUpdated': 'Posodobljeno',
	'sortName': 'Ime',

	'viewAs': 'Prikaži kot',
	'thumbnailsView': 'Prikaži kot sličice',
	'listView': 'Prikaži kot seznam',
	'createMenu': 'Ustvari',
	'newAppItem': 'Delovna tabla',
	'newDataSet': 'Nabor podatkov',

	'menuSelectionState_a11y': 'Izbirnik "%{item}" je nastavljen na "%{selectedItem}"',

	'unableToShareItem': 'Postavke "%{item}" ni mogoče dati v skupno rabo.',
	'toastFetchingContent': 'Pridobivanje več vsebine ...',
	'unableToGetData': 'Vsebine ni mogoče pridobiti.',
	'unableToFavorite': 'Spreminjanje statusa Priljubljeno ni uspelo.',
	'hpErrorMissingRequiredOptions': 'Manjkajoče obvezne možnosti inicializacije',
	'unableToOpenBoard': '"%{name}" ni mogoče odpreti.',
	'unableToDuplicateBoard': '"%{name}" ni mogoče podvojiti.',
	'unableToCreateBoard': '"%{name}" ni mogoče ustvariti.',
	'unableToCreateBoardNameConflict': 'Sredstvo z enakim imenom že obstaja.',

	// DataSet Detail View
	'status': 'Status',
	'numberOfRows': 'Vrstice',
	'importWarnings': 'Opozorila',
	'lineNumbers': 'Vrstice',
	'excerptFromSource': 'Izvleček',
	'reason': 'Vzrok',
	'numberOfRowsDropped': 'izbrisanih vrstic',
	'oneRowDropped': '1 vrstica je bila izbrisana',

	// Type Menu
	'typeMenuLabel': 'Tip',
	'dashboardsLabel': 'Delovne table',
	'datasetsLabel': 'Nabori podatkov',
	'storiesLabel': 'Zgodbe',
	'allLabel': 'Vsi tipi',

	// Board Page View App Bar
	'datasets': 'Nabori podatkov',
	'settings': 'Lastnosti',
	'add': 'Dodaj',
	'widgets': 'Gradniki',
	'dashboardProperties': 'Lastnosti delovne table',
	'searchPanel' : 'Iskanje',
	'pins': 'Zbirka',
	'pinsOld': 'Moje priponke',
	'pinsDateFilterHeading' : 'Datum pripenjanja',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} priponka |||| %{smart_count} priponk',
	'pinSearch': 'Iskanje',
	'pinSearchOld': 'Iskanje priponk',
	'pinListView': 'Seznamski pogled',
	'pinIconView': 'Pogled ikon',
	'pinRemove': 'Odstrani',
	'pinCreate': 'Ustvari',
	'pinDeleteError': 'Iz zbirke ni mogoče izbrisati enega ali več sredstev. Poskusite znova pozneje.',
	'pinDeleteErrorOld': 'Ene ali več priponk ni mogoče izbrisati. Poskusite znova pozneje.',
	'pinRetrieveError': 'Ene ali več priponk ni mogoče pridobiti. Poskusite znova pozneje.',
	'NoPinsCollected': 'Ni pripetih vizualizacij',
	'pinDeletedToast': 'Priponka je bila odstranjena',
	'pinAddedToast': 'Priponka je bila uspešno dodana med Moje priponke',
	'pinningToast': 'Obdelovanje priponke ...',
	'pinDateFilter': 'Datumski filter',
	'pinDateFilterAll': 'Vse',
	'pinDateFilterToday': 'Danes',
	'pinDateFilterYesterday': 'Včeraj',
	'pinDateFilterPastWeek': 'Prejšnji teden',
	'pinDateFilterPastMonth': 'Prejšnji mesec',
	'pinDateFilterEarlier': 'Prej',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Urejanje naslova',
	'toolbarActionSort': 'Razvrsti',
	'toolbarActionSortAscending': 'Razvrsti naraščajoče',
	'toolbarActionSortDescending': 'Razvrsti padajoče',
	'toolbarActionSortAuto': 'Samodejno (%{sortOrder})',
	'toolbarActionFormat': 'Oblika zapisa podatkov',
	'toolbarActionFormatAbbreviation': 'Okrajšano',
	'toolbarActionFormatNone': 'Samodejno',
	'toolbarActionFilter': 'Filter',
	'toolbarActionTopBottom': 'Zgoraj ali spodaj',
	'toolbarActionAddShape': 'Dodaj obliko',
	'toolbarActionRmvShape': 'Odstrani obliko',
	'toolbarActionToggleShapeDrop': 'Oblika vizualne predstavitve',
	'toolbarActionToggleShapeDropTitle': 'Ustvarite vizualno predstavitev',
	'toolbarActionToggleShapeDropText': 'V to polje povlecite obliko, da ustvarite vizualno predstavitev.',
	'toolbarActionAggregationType': 'Seštej',
	'toolbarDeleteActionText': 'Odstrani stolpec',
	'toolbarActionFilterLocalKeepSelected': 'Ohrani',
	'toolbarActionFilterLocalExcludeSelected': 'Izključi',
	'toolbarActionFilterAllKeepSelected': 'Filter',
	'toolbarActionSimpleCalculation': 'Preprost izračun',
	'toolbarActionDrillBack': 'Nazaj',
	'toolbarActionDrillUp': 'Vrtaj navzgor',
	'toolbarActionDrillDown': 'Vrtaj navzdol',
	'toolbarActionNavigate': 'Navigacija',
	'toolbarActionCreateFilterGroup': 'Ustvari novo povezavo',
	'toolbarActionDisconnectFilterGroup': 'Prekini vse povezave',
	'toolbarActionLinkFilterGroup': 'Dodaj v obstoječo povezavo',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Dodaj',
	'sidebarMultiselect': 'Preklopi večkratni izbor',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': 'Izbrano: %{count}',

	'multiselectWithTotalMsg': '%{count} od %{total}',
	'sidebarGoBack': 'Pojdi nazaj',

	//DataSet pane
	'errorLoadingDataSets': 'Tega nabora podatkov ni mogoče naložiti',
	'errorLoadingDataSetMetaData': 'Tega nabora podatkov ni mogoče naložiti',
	'dataSetPaneLastUpdated': 'Zadnja posodobitev: %{date}',
	'dataSetPaneDateUnknown': 'Neznano',
	'sourcePaneLabel': 'Izbrani izvori',
	'addSourceLabel': 'Dodaj izvor',
	'find_label': 'Najdi',
	'navigationPathsLabel': 'Navigacijske poti',

	//widgetlist
	'errorLoadingWidgetList': 'Objektov ni mogoče naložiti.',
	'errorLoadingThemeFile': 'Definicije teme ni mogoče naložiti',
	'errorLoadingLayoutFile': 'Pogleda ni mogoče naložiti.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Razpoložljivih definicij vizualizacije ni mogoče naložiti',

	'dwErrorLoadingVisualizationNotFound': 'Objekta ni mogoče naložiti, ker mu manjka definicija vizualizacije',
	'dwErrorLoadingVisualizationListNotFound': 'Vizualizacije ni mogoče naložiti.',
	'dwErrorRunningQuery': 'Podatkov iz nabora podatkov %{datasetName} ni mogoče pridobiti.',
	'dwErrorGeoData': 'Prišlo je do težav s prikazovanjem geografskih podatkov na zemljevidu. Izberite drug tip vizualizacije. ',
	'dwPromptSignonCancelWarning': 'Podatki za to vizualizacijo niso na voljo. Podajte pravilne poverilnice.',
	'dwErrorMissingDataset': 'Vizualizacije ni mogoče naložiti, ker njen povezan nabor podatkov \'%{datasetName}\' ni na voljo.',
	'dwErrorRenderingVisualization': 'Vizualizacije ni mogoče naložiti.',
	'dwErrorVisualizationTooSmall': 'Vizualizacija je premajhna za prikaz podatkov, ki jih vsebuje. Vizualizacijo naredite večjo ali omejite podatke, ki jih vsebuje.',
	'aria_label_datatable': 'Podatkovna tabela',
	'aria_key_navi_datatable_desc': 'S pomočjo smernih tipk se pomikajte med posameznimi celicami. Pritisnite tipki Control in Home, da se pomaknete na prvo vrstico, ter tipki Control in End, če se želite pomakniti na zadnjo vrstico.',
	'geomapUnrecognizedLocations': 'Neprepoznane lokacije:',
	'geomapAmbiguousLocations': 'Dvoumna območja:',

	// custom widget
	'customWidget': 'Gradnik po meri',
	'customWidgetsTitle': 'Gradniki po meri',
	'noCustomWidgets': 'Ni gradnikov po meri',

	// Action names
	'toggleContextBar': 'Preklopi kontekstno vrstico',
	'delete': 'Izbriši',
	'share': 'Daj v skupno rabo',
	'unshare': 'Odstrani iz skupne rabe',
	'rename': 'Preimenuj',
	'close': 'Zapri',
	'duplicate': 'Podvoji',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Poskusi znova',

	'changeTemplate': 'Spremeni predlogo',

	// Aggregation Types
	'sum': 'Vsota',
	'count': 'Število',
	'countdistinct': 'Razlikovalno štetje',
	'avg': 'Povprečno',
	'min': 'Minimum',
	'max': 'Maksimum',
	'custom': 'Po meri',
	'calculated': 'Izračunano',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% spremembe',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Kriteriji vizualizacije ...',
	'QuickAddResultsHeader': 'Podatkovne vizualizacije',
	'NoQuickAddResults': 'Ni ujemanj z vašo namero. Ali želite ustvariti nov nabor podatkov?',
	'NoQuickAddResultsRetry': 'Najti ni mogoče nobenih ujemanj. Poskusite znova z drugačnimi izrazi.',
	'templateWidgetTitle': 'Predloga',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(prazno)',

	'nullValueContent': '(brez vrednosti)',
	'nullValueText': 'Ničelno',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Besedilni filter - %{columnName}',

	'textFilterSelectTab': 'Izberi',

	'textFilterConditionTab': 'Nastavi pogoj',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Na voljo ni nobene postavke.',

	'textFilterEquals': 'Je enako',
	'textFilterContains': 'Vsebuje',
	'textFilterBeginsWith': 'Začne se z',
	'textFilterEndsWith': 'Konča se z',
	'textFilterDoesNotEqual': 'Ni enako',
	'textFilterDoesNotContain': 'Ne vsebuje',
	'textFilterDoesNotBeginWith': 'Se ne začne z',
	'textFilterDoesNotEndWith': 'Se ne konča z',
	'textFilterSampleText': 'Na primer: A',

	'textFilterAndButton': 'In',
	'textFilterOrButton': 'Ali',

	'dateFilterMessage': 'Izberi datumski obseg',
	'dateRangeControlRegionLabel': 'Filter datumskega obsega - %{columnName}',
	'dateFilterRangeOption': 'Možnost obsega',
	'dateFilterDateLabel': 'Datum',
	'dateFilterBlank': '(prazno)',
	'dateFilterBefore': 'Pred',
	'dateFilterAfter': 'Po',
	'dateFilterBetween': 'Med',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': 'Datum',
	'dateIncludeBlankLabel': 'Vključi prazen datum',

	'timeTitle': 'Čas',
	'timeFilterMessage': 'Izberite časovni obseg',
	'dateTimeFilterMessage': 'Izberite obseg datumov in časov',

	'topbottomNumberOfResultsLabel': 'Število rezultatov',
	'topbottomPercentLabel': 'Odstotek',
	'topbottomNumberOfResultsLimit': 'Med %{lower}-%{higher}',
	'topbottomSelectOption': 'Možnost zgoraj ali spodaj',
	'topbottomOptionLabel': 'Pokaži',
	'searchByLabel': 'Po',
	'searchNoMatches': 'Najdeno ni bilo nobeno ujemanje',
	'topbottomRankColumnLabel': 'Dodaj stolpec ranga v tabelo',
	'topbottomNone': 'Brez',
	'topCount': 'Število zgornjih',
	'topPercent': '% zgornjih',
	'bottomCount': 'Število spodnjih',
	'bottomPercent': '% spodnjih',
	'topbottomSearchColumn': 'Najdi stolpec',
	'searchColumnAriaLabel': 'Najdite stolpec. Vnesite ime stolpca, ki ga želite poiskati, nato pa s puščico navzdol poiščite stolpec na seznamu',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Počisti',

	'rangeFilterControlRegionLabel': 'Filter obsega - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Kontrolnik drsnika, za pomik ročk drsnika uporabite puščice desno in levo',
	'sliderHandleLabel': 'Ročka drsnika',
	'a11ySliderHandleLabel': 'Ročka drsnika %{sliderValue}',
	'sliderInputLabel': 'vrednost',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Nekatere postavke nabora podatkov, uporabljene v tej vizualizaciji, niso na voljo.',
	'datasetItemUnavailable': 'Ta postavka nabora podatkov ni na voljo',

	//Authoring topBottom
	'topOperator': 'Zgoraj',
	'bottomOperator': 'Spodaj',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} po %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Samo ta objekt',
	'deleteTopBottom': 'Izbriši število zgornjih ali spodnjih',
	'editTopBottom': 'Urejanje števila zgornjih ali spodnjih',
	'deleteDrillState': 'Izbriši trenutno stanje vrtanja',
	'ariaDeleteDrillStateLabel': 'Pritisnite tipko ENTER, da uredite število zgornjih ali spodnjih.',
	'drillUpStateTitle': 'Vrtaj navzgor',
	'drillDownStateTitle': 'Vrtaj navzdol',
	'ariaEditTopBottomLabel': 'Pritisnite tipko ENTER, da uredite število zgornjih ali spodnjih.',
	'ariaDeleteTopBottomLabel': 'Pritisnite tipko DELETE, da izbrišete število zgornjih ali spodnjih.',

	// Authoring filtering
	'dimFilterIn': 'Vključuje: %{in}',
	'dimFilterNotIn': 'Izključuje: %{out}',
	'measureFilterBetween': 'Med %{lowerBound} in %{upperBound}',
	'measureFilterNotBetween': 'Ni med %{lowerBound} in %{upperBound}',
	'gtFilter': 'Po %{lowerBound}',
	'ltFilter': 'Pred %{upperBound}',
	'notGtFilter': 'Ni po %{lowerBound}',
	'notLtFilter': 'Ni pred %{upperBound}',
	'localFilterTitle': 'Samo ta objekt',
	'globalFilterTitle': 'Vsi objekti',
	'deleteFilter': 'Izbriši filter',
	'editFilter': 'Urejanje filtra',
	'ariaEditFilterLabel': 'Pritisnite tipko ENTER, da uredite filter.',
	'ariaDeleteFilterLabel': 'Pritisnite tipko DELETE, da izbrišete filter.',

	// Prompts
	'ariaEditPrompt': 'Pritisnite tipko ENTER, da spremenite vrednosti poziva.',

	'moreDataIndicator': 'Podatki so bili obrezani pri naslednjem št. postavk: %{threshold}. Uveljavite filter, da se prikaže manj zadetkov.',

	// data point filtering
	'dataPointFilterTitle': 'Podatkovne točke',
	'dataPointFilterIncludeSummary': 'Št. vključenih podatkovnih točk: %{valueCount}',
	'dataPointFilterExcludeSummary': 'Št. izključenih podatkovnih točk: %{valueCount}',

	// DB2 connection page
	'db2Database': 'Baza podatkov DB2 (%{jdbcConnection})',
	'db2Title': 'Vzpostavi povezavo z IBM DB2',

	// Database
	'databaseConnectionMessage': 'Podajte podrobnosti o povezavi z bazo podatkov:',
	'connectionString': 'Niz povezave z bazo podatkov',
	'databaseCredentials': 'Poverilnice: ',
	'databaseUserName': 'Uporabniško ime',
	'databasePassword': 'Geslo',
	'databaseConnect': 'Poveži',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Vnesite iskalni izraz:',
	'twitterKeyword': 'Ključna beseda',
	'twitterSearch': 'Iskanje',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Pogleda ni mogoče ustvariti: %{error}\nNeuspela operacija: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Filtri gradnika',
	'missingColumn': 'Manjka: %{columnLabel}',
	'missingFiltering': 'Manjkajoči filtri v naslednjih ID-jih stolpcev:',
	'heatByLabel': 'Toplotni po',
	'evColumns': 'Stolpci',
	'evLocalFilters': 'Lokalni filtri',
	'evExpand': 'Razširi',
	'evFilterTooltip': 'Filter',
	'evAdd': 'Dodaj stolpec',

	// Navigation View
	'navigationBack': 'Nazaj',

	// Pinning
	'contentPinFail': 'Vsebine ni mogoče zbrati. Poskusite znova pozneje.',
	'contentPinFailOld': 'Vsebine ni mogoče pripeti. Poskusite znova pozneje.',

	// Layouts
	'dropZoneLabel': 'Spustite tukaj, da maksimirate',

	//Share
	'shareDefaultPageTitle': 'Stran %{index}',

	'nextPage': 'Naslednja stran',
	'previousPage': 'Prejšnja stran',

	'assetAssembly': 'pogled',

	'toolbar_save': 'Shrani',
	'brgr_saveAs': 'Shrani kot',
	'brgr_refresh': 'Osveži',

	// Save
	'saving': 'Shranjevanje ...',
	'save_success': 'Vaš pogled je bil shranjen.',
	'save_failure': 'Oprostite. Vašega pogleda ni mogoče shraniti. Poskusite znova pozneje.',
	'dashboard_save_success': 'Vaša delovna tabla je bila shranjena.',

	'geminiLeave': 'Zapuščate IBM Watson Analytics.',

	'warning': 'Opozorilo',
	'missingDataSetData': 'Podatki za ta nabor podatkov niso na voljo. Osvežite nabor podatkov ali pa se za dostop do izvora obrnite na skrbnika.',

	// Calculations
	'error_calculation_in_use': 'Izbran izračun je v uporabi in ga ni mogoče izbrisati.',

	'resize': 'Spremeni velikost',
	'rotate': 'Zavrti',
	'moveHandle': 'Premakni gradnik',
	'expandHandle': 'Razširi',
	'panHandle': 'Pomakni',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Pomik v',

	// Slide out titles
	'shapeSlideoutTitle': 'Oblike',
	'textSlideoutTitle': 'Besedilo',
	'mediaSlideoutTitle': 'Medij',
	'visualizationSlideoutTitle': 'Vizualizacije',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Podani JSON ni veljaven. Za več informacij preglejte dnevnik.',

	// Widget type labels
	'shape_label': 'Oblika',
	'image_label': 'Slika',
	'data_label': 'Grafikon',
	'media_label': 'Medij',
	'text_label': 'Besedilo',
	'embedMedia_label': 'Medij',
	'youtube_label': 'Videoposnetek YouTube',
	'webpage_label': 'Spletna stran',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Oblika',
	'noExtraText_shape_numbered': 'Oblika (%{number})',
	'few_shape': 'Skupina toliko oblik: %{count}',
	'many_shape': 'Skupina toliko oblik: %{count}',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': 'Slika %{text}',
	'one_image_numbered': 'Slika %{text} (%{number})',
	'noExtraText_image': 'Slika',
	'noExtraText_image_numbered': 'Slika (%{number})',
	'few_image': 'Skupina toliko slik: %{count}',
	'many_image': 'Skupina toliko slik: %{count}',
	'noExtraText_text': 'Prazno besedilno polje',
	'noExtraText_text_numbered': 'Prazno besedilno polje (%{number})',
	'few_text': 'Skupina toliko besedilnih polj: %{count}',
	'many_text': 'Skupina toliko besedilnih polj: %{count}',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube Viewer',
	'pacubeviewer_named': '%{name} Cube Viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': 'Navzkrižna tabela %{values} po %{row_level1} in %{column_level1}',
	'crosstab_opt_mapping_numbered': 'Navzkrižna tabela %{values} po %{row_level1} in %{column_level1} (%{number}) ',
	'crosstab_has_mapping': 'Navzkrižna tabela %{values} po %{row_level1}',
	'crosstab_has_mapping_numbered': 'Navzkrižna tabela %{values} po %{row_level1} (%{number})',
	'crosstab_no_mapping': 'Prazna navzkrižna tabela',
	'crosstab_no_mapping_numbered': 'Prazna navzkrižna tabela (%{number})',
	'crosstab_named': 'Navzkrižna tabela %{name} ',
	'crosstab_named_numbered': 'Navzkrižna tabela %{name} (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': 'Tabela %{grid_cols} ',
	'JQGrid_has_mapping_numbered': 'Tabela %{grid_cols} (%{number})',
	'JQGrid_no_mapping': 'Prazna tabela',
	'JQGrid_no_mapping_numbered': 'Prazna tabela (%{number})',
	'JQGrid_named': 'Tabela %{name} ',
	'JQGrid_named_numbered': 'Tabela %{name} (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': 'Hierarhija %{level1}',
	'hierarchy_has_mapping_numbered': 'Hierarhija %{level1} (%{number})',
	'hierarchy_no_mapping': 'Prazna hierarhija',
	'hierarchy_no_mapping_numbered': 'Prazna hierarhija (%{number})',
	'hierarchy_named': 'Hierarhija %{name}',
	'hierarchy_named_numbered': 'Hierarhija %{name} (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': 'Preslikava %{categories}',
	'map_has_mapping_numbered': 'Preslikava %{categories} (%{number})',
	'map_no_mapping': 'Prazna preslikava',
	'map_no_mapping_numbered': 'Prazna preslikava (%{number})',
	'map_named': 'Preslikava %{name}',
	'map_named_numbered': 'Preslikava %{name} (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': 'Vrednost seštevka %{actual}',
	'summary_has_mapping_numbered': 'Vrednost seštevka %{actual} (%{number})',
	'summary_no_mapping': 'Prazna vrednost seštevka',
	'summary_no_mapping_numbered': 'Prazna vrednost seštevka (%{number})',
	'summary_named': 'Vrednost seštevka %{name}',
	'summary_named_numbered': 'Vrednost seštevka %{name} (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': 'KPI %{actual} po %{sparkline.time}',
	'kpi_opt_mapping_numbered': 'KPI %{actual} po %{sparkline.time} (%{number})',
	'kpi_has_mapping': 'KPI %{actual} ',
	'kpi_has_mapping_numbered': 'KPI %{actual} (%{number})',
	'kpi_no_mapping': 'Prazen KPI',
	'kpi_no_mapping_numbered': 'Prazen KPI (%{number})',
	'kpi_named': 'KPI %{name} ',
	'kpi_named_numbered': 'KPI %{name} (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': 'Vizualna predstavitev %{actual}',
	'infographicSummary_has_mapping_numbered': 'Vizualna predstavitev %{actual} (%{number})',
	'infographicSummary_no_mapping': 'Prazna vizualna predstavitev',
	'infographicSummary_no_mapping_numbered': 'Prazna vizualna predstavitev (%{number})',
	'infographicSummary_named': 'Vizualna predstavitev %{name}',
	'infographicSummary_named_numbered': 'Vizualna predstavitev %{name} (%{number})',
	'noExtraText_youtube': 'Videoposnetek YouTube',
	'noExtraText_youtube_numbered': 'Videoposnetek YouTube (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': 'Videoposnetek YouTube %{text}',
	'one_youtube_numbered': 'Videoposnetek YouTube %{text} (%{number})',
	'few_youtube': 'Skupina toliko videoposnetkov YouTube: %{count}',
	'many_youtube': 'Skupina toliko videoposnetkov YouTube: %{count}',
	'noExtraText_embedMedia': 'Povezava na medij',
	'noExtraText_embedMedia_numbered': 'Povezava na medij (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': 'Povezava na medij %{text}',
	'one_embedMedia_numbered': 'Povezava na medij %{text} (%{number})',
	'few_embedMedia': 'Skupina toliko povezav na medij: %{count}',
	'many_embedMedia': 'Skupina toliko povezav na medij: %{count}',
	'noExtraText_media': 'Medij',
	'noExtraText_media_numbered': 'Medij (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': 'Medij %{text}',
	'one_media_numbered': 'Medij %{text} (%{number})',
	'few_media': 'Skupina toliko medijev: %{count}',
	'many_media': 'Skupina toliko medijev: %{count}',
	'noExtraText_webpage': 'Spletna stran',
	'noExtraText_webpage_numbered': 'Spletna stran (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': 'Spletna stran %{text}',
	'one_webpage_numbered': 'Spletna stran %{text} (%{number})',
	'few_webpage': 'Skupina toliko spletnih strani: %{count}',
	'many_webpage': 'Skupina toliko spletnih strani: %{count}',
	'one_unknown': 'Objekt',
	'one_unknown_numbered': 'Objekt (%{number})',
	'few_unknown': 'Skupina toliko objektov: %{count}',
	'many_unknown': 'Skupina toliko objektov: %{count}',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Naprej',
	'previous': 'Nazaj',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Trenutna navigacijska skupina je %{navigation_group_name}',

	//Page Context
	'filterBlank': '(prazno)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Vrednosti filtrov ni mogoče naložiti',
	'editTimelineHighlight': 'Urejanje označitve',

	'filterDockChevronLeft': 'Pomakni se prek podatkov',
	'filterDockChevronRight': 'Pomakni se prek podatkov',
	'expand': 'Razširi',
	'collapse': 'Strni',

	//Reset Dashboard
	'dashboardResetTitle': 'Ponastavi delovno tablo',
	'dashboardResetMessage': 'Ali ste prepričani, da želite ponastaviti vse spremembe, uveljavljene za to delovno tablo?',
	'dashboardResetToast': 'Delovna tabla je ponastavljena.',

	//Generate PDF
	'buildingPDF': 'Gradnja PDF-ja ...',
	'exportPDF': 'Izvozi v PDF',
	'pageSize': 'Velikost strani',
	'orientation': 'Usmerjenost',
	'filtersPresentPDF': 'Za vizualizacije na prejšnji strani so bili uveljavljeni filtri:',
	'errorPDF': 'Datoteke PDF ni mogoče generirati. Osvežite in poskusite znova.',
	'printPDFInfo': 'Ogled dokumentacije',
	'pdfWidget': 'Gradnik',
	'includeFilters': 'Pokaži podrobnosti filtra',
	'portrait': 'Pokončno',
	'landscape': 'Ležeče',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Delovna tabla je nadgrajena. Shranite ga, da zagotovite optimalno zmogljivost.',

	'ariaFullScreenMessage': 'Za izhod iz celozaslonskega načina pritisnite Escape',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': 'Strnjeni hierarhični mehurčni grafikon %{categories}',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': 'Strnjeni hierarhični mehurčni grafikon %{categories} (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Prazen strnjeni hierarhični mehurčni grafikon',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Prazen strnjeni hierarhični mehurčni grafikon (%{number})',
	'LIVE_hierarchy_packed_bubble_named': 'Strnjeni hierarhični mehurčni grafikon %{name}',
	'LIVE_hierarchy_packed_bubble_named_numbered': 'Strnjeni hierarhični mehurčni grafikon %{name} (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': 'Grafikon Marimekko %{categories} po %{values} ',
	'LIVE_marimekko_has_mapping_numbered': 'Grafikon Marimekko %{categories} po %{values} (%{number})',
	'LIVE_marimekko_no_mapping': 'Prazen grafikon Marimekko',
	'LIVE_marimekko_no_mapping_numbered': 'Prazen grafikon Marimekko (%{number})',
	'LIVE_marimekko_named': 'Grafikon Marimekko %{name}',
	'LIVE_marimekko_numbered': 'Grafikon Marimekko %{name} (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': 'Večstopenjski tortni grafikon %{values} ',
	'LIVE_sunburst_has_mapping_numbered': 'Večstopenjski tortni grafikon %{values} (%{number})',
	'LIVE_sunburst_no_mapping': 'Prazen večstopenjski tortni grafikon',
	'LIVE_sunburst_no_mapping_numbered': 'Prazen večstopenjski tortni grafikon (%{number})',
	'LIVE_sunburst_named': 'Večstopenjski tortni grafikon %{name} ',
	'LIVE_sunburst_named_numbered': 'Večstopenjski tortni grafikon %{name} (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': 'Grafikon analize gonilnika %{values}',
	'LIVE_decision_analysis_has_mapping_numbered': 'Grafikon analize gonilnika %{values} (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Prazen grafikon analize gonilnika',
	'LIVE_decision_analysis_no_mapping_numbered': 'Prazen grafikon analize gonilnika (%{number})',
	'LIVE_decision_analysis_named': 'Grafikon analize gonilnika %{name}',
	'LIVE_decision_analysis_named_numbered': 'Grafikon analize gonilnika %{name} (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': 'Črtni in stolpčni grafikon %{categories} po %{columnValue} in %{lineValue} ',
	'LIVE_line_column_opt_mapping_numbered': 'Črtni in stolpčni grafikon %{categories} po  %{columnValue} in %{lineValue} (%{number})',
	'LIVE_line_column_has_mapping': 'Črtni in stolpčni grafikon %{columnValue} in %{lineValue} ',
	'LIVE_line_column_has_mapping_numbered': 'Črtni in stolpčni grafikon %{categories} po  %{columnValue} in %{lineValue} (%{number})',
	'LIVE_line_column_no_mapping': 'Prazen črtni in stolpčni grafikon',
	'LIVE_line_column_no_mapping_numbered': 'Prazen črtni in stolpčni grafikon (%{number})',
	'LIVE_line_column_named': 'Črtni in stolpčni grafikon %{name} ',
	'LIVE_line_column_named_numbered' : 'Črtni in stolpčni grafikon %{name} (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': 'Mehurčni grafikon %{x} po %{y} in %{size} ',
	'LIVE_bubble_chart_has_mapping_numbered': 'Mehurčni grafikon %{x} po %{y} in %{size} (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Prazen mehurčni grafikon',
	'LIVE_bubble_chart_no_mapping_numbered': 'Prazen mehurčni grafikon (%{number})',
	'LIVE_bubble_chart_named': 'Mehurčni grafikon %{name}',
	'LIVE_bubble_chart_named_numbered': 'Mehurčni grafikon %{name} (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': 'Večlični palični grafikon %{actual}',
	'LIVE_bullet_has_mapping_numbered': 'Večlični palični grafikon%{actual} (%{number})',
	'LIVE_bullet_no_mapping': 'Prazen večlični palični grafikon',
	'LIVE_bullet_no_mapping_numbered': 'Prazen večlični palični grafikon (%{number})',
	'LIVE_bullet_named': 'Večlični palični grafikon %{name}',
	'LIVE_bullet_named_numbered': 'Večlični palični grafikon%{name} (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Podatke v tej delovni tabli je zagotovil(a)',
	'showFooterToggleButtonText': 'Pokaži nogo',
	'showFooterSectionText': 'Noga'
});
